/**
 * Z-Index Constants
 * Standardized z-index values to prevent conflicts across the application
 *
 * Usage:
 * import { Z_INDEX } from '../utils/zIndex';
 * className={`fixed top-0 ${Z_INDEX.modal}`}
 */

export const Z_INDEX = {
  // Base layers
  base: 'z-0',
  default: 'z-1',

  // Content layers
  content: 'z-10',
  dropdown: 'z-20',
  sticky: 'z-20',
  overlay: 'z-30',

  // Navigation
  sidebar: 'z-30',
  header: 'z-40',
  commandPalette: 'z-50',

  // Modals and dialogs
  modal: 'z-50',
  modalBackdrop: 'z-40',

  // Tooltips and popovers
  tooltip: 'z-50',
  popover: 'z-50',

  // Maximum
  max: 'z-[100]',
} as const;

/**
 * Z-index values as numbers for programmatic use
 */
export const Z_INDEX_VALUES = {
  base: 0,
  default: 1,
  content: 10,
  dropdown: 20,
  sticky: 20,
  overlay: 30,
  sidebar: 30,
  header: 40,
  modalBackdrop: 40,
  commandPalette: 50,
  modal: 50,
  tooltip: 50,
  popover: 50,
  max: 100,
} as const;
